import { Injectable } from '@angular/core';
import { AbstractControl, ValidationErrors, Validator } from '@angular/forms';
import { DruhOstatnihoRmBaseValidator } from './druh.ostatniho.rm.base';

/**
 * Kontrola, že je vybrán druh ostatního RM, pokud nejde o semenný RM.
**/
@Injectable({
  providedIn: 'root'
})
export class DruhOstatnihoRmPopValidator extends DruhOstatnihoRmBaseValidator implements Validator {
  validate(control: AbstractControl): ValidationErrors | null {
    let druhRm = control.parent?.get('druhRepMaterialu')?.value;
    return this.doValidation(druhRm, control.value?.kod);
  }
}
